import { Alert, Button, Space, theme } from "antd";
import { ReactElement } from "react";
import CenterContent from "../layouts/CenterContent";

interface AuthenticationFailedProps {
  onTryAgainClick(): void;
}

const AuthenticationFailedScreen = ({ onTryAgainClick }: AuthenticationFailedProps): ReactElement => {
  const { token } = theme.useToken();

  return (
    <CenterContent $backgroundColor={token.colorBgContainer} $color={token.colorText} $padding={token.padding}>
      <Space direction="vertical" size="large">
        <Space direction="vertical" size="small">
          <Alert
            showIcon
            type="error"
            message="Failed to log you in. Please try again, or if the issue persist, contact your supervisor."
          />
        </Space>
        <CenterContent>
          <Button type="primary" onClick={onTryAgainClick}>Try again</Button>
        </CenterContent>
      </Space>
    </CenterContent>
  );
};

export default AuthenticationFailedScreen;
